import { makeStyles, withTheme } from '@mui/styles';
import { alpha } from '@mui/material/styles';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import MuiAccordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import grey from '@mui/material/colors/grey';
import { spacing } from 'studio/helpers';

const Accordion = ({ theme, color = grey[500], summary, children, ...props }) => {
  const useAccordionStyles = makeStyles({
    root: {
      border: '1px solid',
      borderColor: alpha(color, 0.6),
      boxShadow: 'none',
      '&:not(:last-child)': {
        borderBottom: 0
      },
      '&:before': {
        display: 'none'
      },
      '&$expanded': {
        margin: 'auto'
      }
    },
    expanded: {}
  });

  const useAccordionSummaryStyles = makeStyles({
    root: {
      // don't show pointer if there are no children and the accordion can't be expanded
      ...(children ? {} : { cursor: 'default !important' }),
      backgroundColor: alpha(color, 0.1),
      borderBottom: '1px solid',
      borderBottomColor: alpha(color, 0.08),
      paddingLeft: theme.spacing(1.5),
      paddingRight: theme.spacing(1.5),
      marginBottom: -1,
      minHeight: 41,
      '&$expanded': {
        minHeight: 41
      },
      '&.Mui-focused': {
        backgroundColor: alpha(color, 0.18)
      }
    },
    content: {
      alignItems: 'center',
      margin: 0,
      '&$expanded': {
        margin: 0
      }
    },
    expandIconWrapper: {
      padding: theme.spacing(1),
      marginRight: -spacing(theme, 1),
      color
    },
    expanded: {}
  });

  const useAccordionDetailsStyles = makeStyles({
    root: {
      backgroundColor: alpha(color, 0.05),
      padding: theme.spacing(1.5),
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2)
    }
  });

  const accordionClasses = useAccordionStyles();
  const accordionSummaryClasses = useAccordionSummaryStyles();
  const accordionDetailsClasses = useAccordionDetailsStyles();

  return (
    <MuiAccordion
      classes={{
        root: accordionClasses.root,
        expanded: accordionClasses.expanded
      }}
      {...props}
    >
      <AccordionSummary
        classes={{
          root: accordionSummaryClasses.root,
          content: accordionSummaryClasses.content,
          expandIconWrapper: accordionSummaryClasses.expandIconWrapper,
          expanded: accordionSummaryClasses.expanded
        }}
        expandIcon={children ? <ExpandMoreIcon /> : null}
      >
        {summary}
      </AccordionSummary>
      {children && (
        <AccordionDetails
          classes={{
            root: accordionDetailsClasses.root
          }}
        >
          {children}
        </AccordionDetails>
      )}
    </MuiAccordion>
  );
};

export default withTheme(Accordion);
